exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".fullWidth{width:100%}.whatsmore-title{font-weight:600;font-stretch:normal;font-style:normal;line-height:1.24;letter-spacing:normal;font-size:1.75rem;text-align:center;color:#282c3f;text-transform:uppercase;margin:5px}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/UI/FrontEnd-PROD-With-AutoScaling/src/components/whatsMore.vue"],"names":[],"mappings":"AACA,WACI,UAAW,CACd,AACD,iBACE,gBAAiB,AACf,oBAAqB,AACrB,kBAAmB,AACnB,iBAAkB,AAClB,sBAAuB,AACvB,kBAAmB,AACnB,kBAAmB,AACnB,cAAe,AACf,yBAA0B,AAC1B,UAAY,CACf","file":"whatsMore.vue","sourcesContent":["\n.fullWidth {\n    width:100%;\n}\n.whatsmore-title{\n  font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.24;\n    letter-spacing: normal;\n    font-size: 1.75rem;\n    text-align: center;\n    color: #282c3f;\n    text-transform: uppercase;\n    margin: 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-733d8c3b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/whatsMore.vue
// module id = 1970
// module chunks = 73